export const convertObjectArrayToString = objectArray => {
  if (Array.isArray(objectArray)) {
    const str = objectArray
      .filter(a => a.value !== 0)
      .map(a => `${Object.values(a).join(' ')}`)
      .join(', ')
      .replace('CubicYard', 'Cubic yard')
      .replace('Pound', 'lbs')
    return str
  }
  return objectArray
}
